<template>
  <div class="be-max-modal" v-if="checkBeMax">
    <div
      class="be-max-modal__container-img"
      @click="showModal('first')"
      v-if="mode == 'img'"
    >
      <div class="be-max-modal__img">
        <img src="@/assets/img/bemax.png" />
      </div>
      <button class="be-max-modal__button">
        <p v-if="label">{{ label }}</p>
        <p class="mb-0">Veja como melhorar seus resultados</p>
      </button>
    </div>

    <div class="be-max-modal__container-line" v-else>
      <button class="be-max-modal__text" @click="showModal('first')">
        <i class="icon-nav-insight" />
        <span>Veja como melhorar seus resultados</span>
        <i class="icon-nav-arrow_right" />
      </button>
    </div>
  </div>

  <Dialog
    class="be-max-modal__first-dialog"
    :visible="modals.first"
    :draggable="false"
    :modal="true"
    :closable="true"
    @update:visible="hideModal('first')"
  >
    <template #header>
      <header>
        <h1>{{ beMax.title }}</h1>
        <h2>{{ beMax.subtitle }}</h2>
      </header>
    </template>

    <p>{{ beMax.message }}</p>

    <template #footer>
      <div>
        <button @click="showModal('second')">
          <i class="icon-nav-arrow_right" />
          Clique aqui
        </button>
      </div>
    </template>
  </Dialog>

  <Dialog
    class="be-max-modal__second-dialog"
    :visible="modals.second"
    :draggable="false"
    :modal="true"
    :closable="true"
    @update:visible="hideModal('second')"
  >
    <template #header>
      <header>
        <h1>Essa lista ajudará você a alcançar seus objetivos!</h1>
      </header>
    </template>

    <ul>
      <template v-for="(item, index) in beMax.resources" :key="index">
        <li @click="showModal('third', item.link)">
          <h3>
            <i class="icon-nav-arrow_right" />
            {{ item.title }}
          </h3>
          <p>
            {{ item.description }}
          </p>
        </li>
      </template>
    </ul>
  </Dialog>

  <Dialog
    class="be-max-modal__third-dialog"
    :visible="modals.third"
    :draggable="false"
    :modal="true"
    :closable="true"
    @update:visible="hideModal('third')"
  >
    <template #header>
      <button @click="hideModal('third')">
        <i class="icon-nav-arrow_left" />
        Voltar para lista de conteúdos
      </button>
    </template>

    <iframe width="100%" height="100%" :src="GoogleDriveVerify(modalPDF)" />
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType } from "vue";
import mixpanel from "mixpanel-browser";

type IBeMax = {
  title: string;
  subtitle: string;
  message: string;
  resources: { title: string; description: string }[];
};

export default defineComponent({
  name: "BeMaxModal",

  props: {
    beMax: {
      type: Object as PropType<IBeMax>,
    },
    mode: { type: String, default: "img" },
    label: { type: String, default: "" },
  },

  setup(props) {
    const modals: any = ref({
      first: false,
      second: false,
      third: false,
    });

    const modalPDF = ref("");

    const checkBeMax = computed(() => {
      if (props.beMax) return Object.keys(props.beMax).length > 0;

      return false;
    });

    const showModal = (modal: string, content = "") => {
      if (content) modalPDF.value = content;

      if (modal == "second") hideModal("first");

      modals.value[modal] = !modals.value[modal];

      if (modal == "first") {
        mixpanel.track("Clique veja como melhorar seus resultados");
      }
    };

    const GoogleDriveVerify = (url: string) => {
      const regex = /\/view\?usp=sharing$|\/view$/g;

      if (url.includes("drive.google.com")) {
        return url.replace(regex, "/preview");
      }

      return url;
    };

    const hideModal = (modal: string) => {
      modals.value[modal] = false;
    };

    return {
      modals,
      showModal,
      checkBeMax,
      hideModal,
      modalPDF,
      GoogleDriveVerify,
    };
  },
});
</script>

<style lang="scss">
.be-max-modal {
  position: relative;

  &__container-img {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__img {
    display: inline-block;
    margin-right: 15px;
  }

  &__button {
    text-align: left;
    font-size: toRem(16px);
    line-height: toRem(21px);
    font-family: "text-medium";
    background: var(--insights-color-2);
    color: var(--insights-color-22);
    border-radius: 6px 6px 6px 0;
    border: none;
    padding: 16px 20px;
    max-width: 216px;
    display: inline-block;
    vertical-align: top;
  }

  &__text {
    border: none;
    background: none;
    font-family: "text-medium";
    font-size: toRem(17px);
    color: var(--insights-color-22);
    display: flex;
    align-items: center;

    i {
      margin-right: 7px;
      vertical-align: top;
      font-size: toRem(17px);
    }

    > i.icon-nav-arrow_right {
      color: var(--insights-color-22);
      margin-left: 10px;
      display: inline-block;
    }
  }

  &__first-dialog {
    width: 50vw;

    .p-dialog-header {
      > header {
        padding: 60px 40px;
        padding-bottom: 0;

        h1 {
          font-size: toRem(45px);
          font-family: "text-medium";
          color: #0d151c;
          margin-bottom: toRem(33px);
        }

        h2 {
          font-size: toRem(30px);
          font-family: "text-regular";
          color: #0d151c;
        }
      }
    }

    .p-dialog-content {
      > p {
        padding: 0 40px;
        font-size: toRem(17px);
        font-family: "text-medium";
        color: var(--insights-color-1);
        margin-bottom: 0;
      }
    }

    .p-dialog-footer {
      text-align: left !important;

      div {
        padding: 0 40px;
        padding-bottom: 40px;

        > button {
          border-radius: 3px;
          border: none;
          padding: toRem(14px);
          background: #0688ff;
          color: var(--insights-color-2);
          text-transform: uppercase;
          font-size: toRem(14px);
          font-family: "text-bold";
          display: flex;
          align-items: center;
          gap: toRem(15px);

          i {
            color: var(--insights-color-2);
            // font-size: toRem(26px);
          }
        }
      }
    }
  }

  &__second-dialog {
    width: 35vw;
    .p-dialog-header {
      > header {
        padding: 60px 40px;
        padding-bottom: 0;

        h1 {
          font-size: toRem(30px);
          font-family: "text-regular";
          color: #0d151c;
        }
      }
    }

    .p-dialog-content {
      > ul {
        list-style: none;
        padding: 0;
        margin: 0;
        padding: 0 40px;

        li {
          cursor: pointer;
          margin-bottom: 34px;

          h3 {
            font-size: toRem(22px);
            font-family: "text-medium";
            color: #0688ff;
            margin-bottom: toRem(5px);
            display: flex;
            align-items: center;
            gap: 7px;

            > i.icon-nav-arrow_right {
              color: #0688ff;
              margin-left: 5px;
              display: inline-block;
              vertical-align: middle;
            }
          }

          p {
            font-size: toRem(17px);
            font-family: "text-medium";
            color: #a3a3a3;
          }
        }
      }
    }
  }

  &__third-dialog {
    width: 80vw;
    box-shadow: none;

    .p-dialog-header {
      background: transparent;

      > button {
        font-family: "text-bold";
        background: #616161;
        border-radius: 3px;
        border: none;
        text-transform: uppercase;
        color: var(--insights-color-2);
        padding: toRem(12px);
        font-size: toRem(13px);
        display: flex;
        align-items: center;
        gap: toRem(13px);

        i {
          color: var(--insights-color-2);
        }
      }
    }

    .p-dialog-content {
      padding: 0 !important;
      height: 80vh;
    }
  }
}
</style>
